var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgResetNfg = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 2.6665V6.6665H4.66699",
    stroke: "#5283FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34033 9.99964C2.77259 11.2266 3.59188 12.2798 4.67476 13.0006C5.75764 13.7214 7.04545 14.0707 8.34414 13.996C9.64282 13.9212 10.882 13.4264 11.8751 12.5861C12.8681 11.7459 13.5612 10.6056 13.8498 9.33722C14.1385 8.06881 14.0071 6.74094 13.4754 5.55371C12.9438 4.36647 12.0407 3.38417 10.9022 2.75482C9.76375 2.12546 8.45159 1.88315 7.16344 2.06438C5.87529 2.24562 4.68093 2.84059 3.76033 3.75964L0.666992 6.66631",
    stroke: "#5283FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResetNfg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reset-nfg.069647d4.svg";
export { ForwardRef as ReactComponent };